import service from '.';
import { decryptData } from './decryptData';

export async function getSelectsEstados() {
  try {
    const { data: estados } = await service.getAll('g', {}, `domUf/list/`);

    const _estados = decryptData(estados);
    const listUF = _estados.map((estado) => ({
      id: estado['codUf'],
      label: estado['nomeUf'],
    }));
    listUF.sort((a, b) => {
      return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
    });

    listUF.unshift({ id: null, label: 'Selecione' });
    return listUF;
  } catch (error) {
    return error;
  }
}

export async function getSelectsCidades(vs, uf) {
  try {
    vs.loading();
    const { data } = await service.getAll(
      'g',
      {},
      `domMunicipio/list/codUf/${uf}`,
    );

    const _data = decryptData(data);

    const cidades = _data.map((cidade) => ({
      id: cidade['idCidade'],
      label: cidade['nomeCidade'],
    }));
    return cidades;
  } catch (error) {
    return error;
  } finally {
    vs.loading.close();
  }
}
